<template>
    <div class="main-wrapper with-tabs no-padding scroll-y custom-scrollbar view-training-single">

        <div class="inner-padding">

            <page-title :title="'Szkolenie'" :back="true" :routeName="'Trainings'"></page-title>

            <div v-if="loading">
                <p><b>Ładuję szkolenie...</b></p>
            </div>

            <div v-else>
                <div v-for="(item,index) in steps" :key="index">
                    <fade-transition :duration="300">
                        <div v-if="index+1 === step" class="item-training-step" style="padding: 0 0 10px 0;">
                            <h4>{{ item.name }}</h4>
                            <img v-if="item.image !== 'default'" :src="item.image" style="width: 100%; height: auto"/>
                            <div v-html="item.content" class="rte"></div>
                            <div v-if="steps.length === 1" v-html="single.subtitle"></div>
                        </div>
                    </fade-transition>
                </div>

                <div v-if="show && steps.length === 0" class="text-center">
                    <p><b>Brak kroków w szkoleniu.</b></p>
                </div>
            </div>

        </div>

        <tab-progress
                :step="step"
                :data="steps"
                @finish="goTo('TrainingTest', $route.params.slug)"
                :finish_button_loading="loading"
                :finish_button_disabled="single ? single.passed_test : false"
                :finish_button_label="'Idź do testu'">
        </tab-progress>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import goTo from '@/mixins/goto';
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import TabProgress from '@/components/TabProgress.vue';

    export default {
        name: 'TrainingSingle',
        components: { PageTitle, TabProgress },
        mixins: [goTo],
        data() {
            return {
                show: false,
                step: 1
            }
        },
        computed: {
            ...mapState({
                loading: state => state.trainings.loading,
                lessons: state => state.trainings.lessons,
                single: state => state.trainings.single,
                steps: state => state.trainings.single.steps,
            })
        },
        mounted() {
            this.show = true;
            this.findTrainingSingle();
        },
        methods: {
            findTrainingSingle(){
                let obj = this.lessons.find(x => x.slug === this.$route.params.slug);
                if(obj){
                    this.$store.commit('trainings/KNOWLEDGE_TRAININGS_SET_SINGLE', obj);
                }else{
                    this.$store.dispatch('trainings/KNOWLEDGE_TRAININGS_SINGLE_REQUEST', this.$route.params.slug);
                }
            }
        }
    }
</script>